<template>
  <section id="dashboard-ecommerce">
    <b-row class="match-height">
      <b-col
        xl="4"
        md="6"
      >
        <UserCardLandingPage />
      </b-col>
      <b-col
        xl="8"
        md="6"
      >
        <WhatsNew />
        <!-- <CardAdvanceTimeline /> -->
      </b-col>
    </b-row>

    <b-row class="match-height">
      <b-col lg="5">
        <b-row class="match-height">
          <!-- <b-col
            lg="12"
            md="12"
            cols="12"
          >
            <PendingApprovals />
          </b-col> -->
          <b-col
            lg="12"
            md="12"
            cols="12"
          >
            <FavoriteWidget />
          </b-col>

        </b-row>
      </b-col>
      <b-col lg="7">

        <b-col
          lg="12"
          md="12"
        >
          <QuicklinksWidget />
        </b-col>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
// import PendingApprovals from './PendingApprovals.vue'
import { useActions } from 'vuex-composition-helpers'
import { onMounted } from '@vue/composition-api'
import UserCardLandingPage from './UserCardLandingPage.vue'
import WhatsNew from './WhatsNew.vue'
import FavoriteWidget from './FavoriteWidget.vue'
import QuicklinksWidget from './QuicklinksWidget.vue'
import { dashboardPermissions } from '../../../helpers/permissions'

export default {
  components: {
    BRow,
    BCol,

    UserCardLandingPage,
    // PendingApprovals,
    WhatsNew,
    FavoriteWidget,
    QuicklinksWidget,
  },
  setup() {
    const {
      getTillAccountList,
      getVaultAccountList,
      getBranches,
      getBanks,
      getAllBankList,
      getIncomeGLAccount,
      getIncomeGLByParentCategory,
      getStationaryAccount,
      getCurrentFinancialDate,
      getCorporateInformation,
    } = useActions({
      getTillAccountList: 'operations/getTillAccountList',
      getVaultAccountList: 'operations/getVaultAccountList',
      getBranches: 'operations/getAllBranches',
      getBanks: 'operations/getBanks',
      getAllBankList: 'eChannels/getAllBankList',
      getIncomeGLAccount: 'account/getIncomeGLAccount',
      getIncomeGLByParentCategory: 'account/getIncomeGLByParentCategory',
      getStationaryAccount: 'account/getStationaryAccount',
      getCurrentFinancialDate: 'operations/getCurrentFinancialDate',
      getCorporateInformation: 'operations/getCorporateInformationList',
    })

    const fetchData = async () => {
      await getCorporateInformation({ permission: dashboardPermissions.LANDING_PAGE })
      await getVaultAccountList({
        search: '',
        page: 0,
        limit: 1000,
        permission: 'LANDING_PAGE',
      })
      await getTillAccountList({
        search: '',
        page: 0,
        limit: 1000,
        permission: 'LANDING_PAGE',
      })
      await getBanks({ permission: 'LANDING_PAGE' })
      await getAllBankList({ permission: 'LANDING_PAGE' })
      await getCurrentFinancialDate({ permission: 'LANDING_PAGE' })
      await getBranches({
        search: '',
        page: 0,
        limit: 0,
        permission: 'LANDING_PAGE',
      })
      await getIncomeGLAccount({ permission: 'LANDING_PAGE' })
      await getIncomeGLByParentCategory({ permission: 'LANDING_PAGE' })
      await getStationaryAccount({ permission: 'LANDING_PAGE' })
    }
    onMounted(async () => {
      await fetchData()
    })
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/dashboard-ecommerce.scss';
@import '@core/scss/vue/libs/chart-apex.scss';
</style>
